module.exports = __webpack_public_path__ + "img/Fish.389dfffb.svg";